import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { isVisible } from "@grindex-common/helpers/domManipulation";

const CLASS_SELECTED = "selected";
const CLASS_CAPTION = "image-caption";

const SELECTOR_OVERLAY = "[xyl-element='image-overlay']";
const SELECTOR_CAROUSEL = ".carousel";
const SELECTOR_FEATURED_IMAGE = ".featured-image";
const SELECTOR_FIRST_SLIDE = "ul.thumbnails li:first-child";
const SELECTOR_THUMBNAIL_UL = "ul.thumbnails";

function getIESafeElement(event) {
	return event.currentTarget.tagName.toLowerCase() === "img" ? event.currentTarget : event.currentTarget.parentElement.querySelector("img");
}

export class ImageOverviewDom extends DomElementsBase {
	constructor($module) {
		super($module, [SELECTOR_OVERLAY, SELECTOR_CAROUSEL, SELECTOR_FEATURED_IMAGE, SELECTOR_FIRST_SLIDE, SELECTOR_THUMBNAIL_UL]);
	}

	getOverlayElements() {
		return this.getElements(SELECTOR_OVERLAY);
	}

	getImageElements() {
		return this.getDescendentsByTag(SELECTOR_THUMBNAIL_UL, "img");
	}

	getCarouselElement() {
		return this.getElement(SELECTOR_CAROUSEL);
	}

	getFeaturedImageElement() {
		return this.getElement(SELECTOR_FEATURED_IMAGE);
	}

	getFirstSlide() {
		return this.getElement(SELECTOR_FIRST_SLIDE);
	}

	getThumbNailUl() {
		return this.getElement(SELECTOR_THUMBNAIL_UL);
	}

	getExistingVideo($clickedElement) {
		return this.$module.querySelector(`#botr_${$clickedElement.dataset.key}_${$clickedElement.dataset.videoPlayerId}_div`);
	}

	getListItemElements() {
		return this.getChildrenByTag(SELECTOR_THUMBNAIL_UL, "li");
	}

	getClickedImageElement(event) {
		return getIESafeElement(event);
	}

	elementIsSelected($element) {
		return $element && $element.classList.contains(CLASS_SELECTED);
	}

	carouselIsVisible() {
		return isVisible(this.getCarouselElement());
	}

	carouselShouldBeSlider() {
		return this.getListItemElements().length > 1;
	}

	selectListItem($item) {
		this.getListItemElements().forEach(($listItem) => {
			$listItem.classList.remove(CLASS_SELECTED);
		});

		$item.classList.add(CLASS_SELECTED);
	}

	selectFirstSlide() {
		this.getFirstSlide().classList.add(CLASS_SELECTED);
	}

	clearFeaturedImage() {
		this.getFeaturedImageElement().innerHTML = "";
	}

	setFeaturedImage(image) {
		this.clearFeaturedImage();
		this.getFeaturedImageElement().appendChild(image);

		if (image.dataset.caption && image.dataset.caption !== "undefined") {
			const $caption = document.createElement("p");

			$caption.classList = CLASS_CAPTION;
			$caption.innerText = image.dataset.caption;

			this.getFeaturedImageElement().appendChild($caption);
		}
	}
}
